















































































































































import Component, { mixins } from 'vue-class-component'
import Card from '@/components/Card.vue'
import { PaymentsModule } from '@/store/modules/payments.module'
import { getModule } from 'vuex-module-decorators'
import { EPaymentStatus, ESortOrder, EUserPermissions, IPayment, IPaymentStatus, IResident } from '@zunta/configurations'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import Icon from '@/components/Icon.vue'
import { getPaidByLabel } from '@/utils/helpers'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { VPopover } from 'v-tooltip'
import RefundPopup from '@/views/app/management/components/RefundPopup.vue'
import AddressesPopup from '@/views/app/management/components/AddressesPopup.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import NoData from '@/views/app/management/residents/NoData.vue'
import StatusPayment from '@/components/statuses/StatusPayment.vue'
import { ResidentPageMixin } from '@/views/app/management/residents/resident-page/ResidentPageMixin'
import PaymentMethodLabel from '@/components/labels/PaymentMethodLabel.vue'

@Component({
  components: {
    PaymentMethodLabel,
    StatusPayment,
    NoData,
    AddressesPopup,
    RefundPopup,
    DateTimeLabel,
    Icon,
    LoaderWrapper,
    Card,
    VPopover
  }
})
export default class ResidentLastPaymentWidget extends mixins(ResidentPageMixin) {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  EPaymentStatus: any = EPaymentStatus
  getPaidByLabel: any = getPaidByLabel
  user: User = Api.getUser() as User
  isLoading: boolean = false
  refundPayment: any = null
  receiptPaymentId: number = -1

  get residentId () {
    return this.$route.params.id
  }

  get paymentStatusList () {
    return this.$store.state.payments.paymentStatusList
  }

  get lastPaymentItem () {
    if (!this.paymentStatusList || !this.paymentStatusList.length) {
      return null
    }
    return this.paymentStatusList.pop()
  }

  get lastPayment () {
    if (!this.lastPaymentItem) {
      return null
    }
    return this.lastPaymentItem.payment
  }

  get showRefundButton () {
    return this.lastPayment &&
      !this.lastPaymentItem.payment.initialPaymentId &&
      ![EPaymentStatus.PENDING, EPaymentStatus.VOIDED, EPaymentStatus.DECLINED, EPaymentStatus.REFUNDED].includes(this.lastPaymentItem.status) &&
      !this.user.isResident() &&
      this.user.hasPermissionFor(EUserPermissions.REFUND_PAYMENT)
  }

  get appliedToText () {
    return (appliedTo: any) => appliedTo.map((item: any) => {
      return item.transactionEffectiveDate.isCredit
        ? 'Credit for ' + item.transactionEffectiveDate.payerType.payer_name
        : item.transactionEffectiveDate.payerType.payer_name
    }).join(', ')
  }

  mounted () {
    this.fetchData()
    this.$watch('residentId', () => this.fetchData())
  }

  async fetchData () {
    try {
      this.isLoading = true
      await this.paymentsModuleInstance.getResidentPaymentsList({
        residentId: this.residentId,
        filters: {
          limit: 1,
          sortBy: 'paidDate',
          sortOrder: ESortOrder.DESC
        }
      })
    } finally {
      this.isLoading = false
    }
  }

  toggleReceiptPopup (paymentId: number) {
    this.receiptPaymentId = paymentId
  }

  toggleRefundPopup (payment: IPayment | null) {
    this.refundPayment = payment
  }

  goToEditPayment (paymentStatus: IPaymentStatus) {
    this.$locationManager.rememberAndGoTo({
      name: 'payment-one-time-edit',
      params: {
        residentId: ((paymentStatus.payment as IPayment).resident as IResident).id.toString(),
        paymentId: (paymentStatus.payment as IPayment).id.toString()
      }
    })
  }

  showNotInOrigin (paymentStatus: any) {
    const notSync = !paymentStatus.payment.isSync
    const notHmo = !paymentStatus.payment.hmo
    const isDeclineOrVoid = [EPaymentStatus.DECLINED, EPaymentStatus.VOIDED].includes(paymentStatus.status)
    const isEcheckReject = paymentStatus.payment.residentPaymentMethod && paymentStatus.payment.residentPaymentMethod.type === 'ECHECK' && paymentStatus.payment.rejectPayment
    return notSync && notHmo && !(isDeclineOrVoid && !isEcheckReject)
  }
}
